// @flow
export const TOOLTIP_THEME_API = {
  root: '',
  bubble: '',
  alignRight: '',
  alignLeft: '',
  isCentered: '',
  isEmpty: '',
  isShowingOnHover: '',
  isVisible: '',
  nowrap: '',
};
